import React, { memo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation, matchPath, useHistory } from "react-router";

// material core
import MuiDrawer from "@mui/material/Drawer";
import { CSSObject, Theme, styled } from "@mui/material/styles";

import ListSubheader from "@material-ui/core/ListSubheader";
import { appheaderSelector, breadcrumbSelector } from "selectors/app.selector";
import { ReactComponent as LightMenuIcon } from "svgs/light/material-symbols-light_menu.svg";
// import {ReactComponent as Logo} from 'svgs/light/logo.svg';

import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import { changeNavBarView } from "actions/app.action";
import { useDispatch, useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import crowdService from "services/crowdService";

// configs
import { navBarCommon2 } from "routes/navBarCommon";

// types
import { IChildNavBar } from "models/INavBar";
import NavBarItem from "./NavBarItem";

// styles
import useStyles from "./styles";
import clsx from "clsx";
import { userSelector } from "selectors/auth.selector";

type IProps = {
  isDrawer: boolean;
};

type IChildRoutes = {
  acc: any;
  curr: any;
  pathname: string;
  depth?: number;
  label?: string;
  isopen?: boolean;
};

const drawerWidth = 300;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerWrapper = styled(MuiDrawer, {
  shouldForwardProp: (prop: any) => prop !== "open",
})(({ theme, open }: any) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

function NavBar({ isDrawer }: IProps) {
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const { isNavEnlarged } = useSelector(appheaderSelector);
  const userinfo = useSelector(userSelector);

  const [curNavRoutes, setCurNavRoutes] = useState<any[]>([]);
  const [paymentAccess, setPaymentAccess] = useState<any>(null);

  useEffect(() => {
    if (userinfo?.currentuserinfo?.module_accesses) {
      // const tempNavRoutes = userinfo.currentuserinfo.module_accesses.map((module) => {
      //   return navBarCommon2.filter((nav) => nav.moduleAccess === module);
      // });
      let tempNavRoutes = navBarCommon2.filter((nav) => {
        return userinfo.currentuserinfo.module_accesses?.includes(
          nav.moduleAccess
        );
      });
      if (
        userinfo.currentuserinfo.module_accesses?.includes(19) &&
        userinfo.currentuserinfo.module_accesses?.includes(21)
      ) {
        tempNavRoutes = tempNavRoutes.filter((nav) => nav.moduleAccess !== 21);
      }

      // NOTE: giving access to payments, only if has write or read access
      if (
        !(
          paymentAccess &&
          ["write", "read"].includes(paymentAccess?.access?.toLowerCase())
        )
      ) {
        tempNavRoutes = tempNavRoutes.filter((nav) => nav.moduleAccess !== 29);
      }

      setCurNavRoutes(tempNavRoutes);
    }
  }, [userinfo, paymentAccess]);

  useEffect(() => {
    if (userinfo?.currentuserinfo?.module_accesses) {
      crowdService
        .getPaymentAccess()
        .then((res) => {
          setPaymentAccess(res?.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [userinfo]);

  // const renderNavItems = ({ items, pathname, depth, open }: IChildNavBar) => {
  //   return (
  //     <List disablePadding>
  //       {items?.reduce(
  //         (acc, curr) => renderChildRoutes({ acc, curr, pathname, depth }),
  //         []
  //       )}
  //     </List>
  //   );
  // };

  // const renderChildRoutes = ({ acc, curr, pathname, depth = 0 }: IChildRoutes) => {
  //   const key = curr.title + depth;
  //   const open = matchPath(pathname, {
  //     path: curr.href,
  //     exact: false,
  //   });

  //   if (curr.items && isNavEnlarged) {
  //     acc.push(
  //       <NavBarItem
  //         key={`multi-${key}`}
  //         depth={depth}
  //         icon={curr.icon}
  //         selectedicon={curr.selectedIcon}
  //         open={Boolean(open)}
  //         title={curr.title}
  //         href={curr.href}
  //         label={curr.label}
  //         isExternalLink={curr.isExternalLink}
  //       >
  //         {renderNavItems({
  //           depth: depth + 1,
  //           pathname,
  //           items: curr.items,
  //         })}
  //       </NavBarItem>
  //     );
  //   } else {
  //     acc.push(
  //       <NavBarItem
  //         key={`alone-${key}`}
  //         depth={depth}
  //         selectedicon={curr.selectedIcon}
  //         href={curr.href}
  //         open={Boolean(open)}
  //         icon={curr.icon}
  //         title={curr.title}
  //         label={isNavEnlarged ? curr.label : ""}
  //         isExternalLink={curr.isExternalLink}
  //       />
  //     );
  //   }
  //   return acc;
  // };

  // const renderNavbarCommon = (navbars: any) => {
  //   return (
  //     <>
  //       {navbars.map((nav: any) => {
  //         return (
  //           <List
  //             key={nav.subheader}
  //             subheader={<ListSubheader disableSticky>{nav.subheader}</ListSubheader>}
  //           >
  //             {renderNavItems({ items: nav.items, pathname: location.pathname })}
  //           </List>
  //         );
  //       })}
  //     </>
  //   );
  // };

  return (
    <DrawerWrapper
      className={classes.drawer}
      variant="permanent"
      open={isNavEnlarged}
      classes={{
        paper: classes.drawerPaper,
      }}
      onMouseEnter={() => {
        // Open on hover when collapsed
        if (!isNavEnlarged) {
          dispatch(changeNavBarView());
        }
      }}
      onMouseLeave={() => {
        // Close on hover loss when expanded
        if (isNavEnlarged) {
          dispatch(changeNavBarView());
        }
      }}
    >
      <DrawerHeader
        className={
          !isNavEnlarged
            ? classes.drawerHeader
            : clsx([classes.drawerHeader, classes.drawerHeaderOpen])
        }
      >
        {isNavEnlarged && (
          <div
            style={{
              visibility: isNavEnlarged ? "visible" : "hidden",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={"/assets/images/logo.png"}
              alt="logo"
              style={{ width: "40px", height: "40px" }}
            />
            <span>AMT</span>
          </div>
        )}
        <IconButton onClick={() => dispatch(changeNavBarView())}>
          <LightMenuIcon />
        </IconButton>
      </DrawerHeader>

      <List>
        {!isNavEnlarged && (
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: isNavEnlarged ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: isNavEnlarged ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                {/* <Logo/> */}
                <img
                  src={"/assets/images/logo.png"}
                  alt="logo"
                  style={{ width: "40px", height: "40px" }}
                />
              </ListItemIcon>
              <ListItemText sx={{ opacity: isNavEnlarged ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
        )}
        {curNavRoutes.map((data: any, index) => {
          const open = matchPath(location.pathname, {
            path: data.href,
            exact: true,
          });

          return (
            <ListItem
              key={data.title}
              disablePadding
              sx={{ display: "block" }}
              onClick={() => dispatch(changeNavBarView())}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: isNavEnlarged ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={() => history.push(data.href)}
                className={open ? classes.selecteditem : ""}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: isNavEnlarged ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title={data.title} color={open ? "primary" : ""}>
                    {!open ? <data.Icon /> : <data.selectedIcon />}
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={data.title}
                  sx={{ opacity: isNavEnlarged ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </DrawerWrapper>
  );
}

export default memo(NavBar);
